module.exports = __webpack_public_path__ + "static/media/MEDAL_DE.f2528cea.png";